import React, { useEffect, useState } from "react";
import loaderLogo from "@/assets/icons/loader/ic_loader.svg";
import { createUseStyles } from "react-jss";

const useStyle = createUseStyles({
  loader: {
    inset: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#ffffff90",
    position: "fixed",
    zIndex: 9999,
    userSelect: "none",
    opacity: 1,
    visibility: "visible",
    transition: "all 50ms ease",
    height: "auto",
  },

  loaderImg: {
    animation: "$wobble-pulse 2.2s ease 0.2s infinite normal forwards",
  },

  loaderStarting: {
    opacity: "0 !important",
    visibility: "hidden !important",
    height: "0 !important",
  },
  "@keyframes wobble-pulse": {
    "0%": {
      animationTimingFunction: "ease-out",
      transform: "scale(1)",
      transformOrigin: "center center",
    },
    "5%": {
      transform: "rotate(-45deg) scale(1)",
    },

    "20%": {
      animationTimingFunction: "ease-in",
      transform: "scale(1.29) rotate(-45deg)",
    },
    "37%": {
      animationTimingFunction: "ease-out",
      transform: "scale(1.08) rotate(-45deg)",
    },
    "43%": {
      animationTimingFunction: "ease-in",
      transform: "scale(1.25) rotate(-45deg)",
    },

    "55%": {
      animationTimingFunction: "ease-out",
      transform: "scale(1) rotate(-30deg)",
    },
    "80%": {
      animationTimingFunction: "ease-out",
      transform: "scale(1) rotate(0deg)",
    },
  },
});

type LoaderProps = {
  size?: number;
};
const Loader: React.FC<LoaderProps> = ({ size = 95 }) => {
  const classes = useStyle();
  const [showComponent, setShowComponent] = useState(false);

  useEffect(() => {
    const delay = setTimeout(() => {
      setShowComponent(true);
    }, 50);
    return () => {
      clearTimeout(delay);
    };
  }, []);

  return (
    <div className={showComponent ? classes.loader : classes.loaderStarting}>
      <div className={classes.loaderImg}>
        <img src={loaderLogo} alt="" width={size} height={size} />
      </div>
    </div>
  );
};
export default Loader;
